import { Client } from 'xrpl/dist/npm'
import { XRPL_WS_URL } from './config'

let xrplClient: Client | null = null
let connectPromise: Promise<Client> | null = null

export const getXrplClient = async () => {
  if (!xrplClient) {
    xrplClient = new Client(XRPL_WS_URL)
  }

  if (xrplClient.isConnected()) {
    return xrplClient
  }

  if (!connectPromise) {
    connectPromise = xrplClient.connect().then(() => xrplClient)
    connectPromise.finally(() => {
      connectPromise = null
    })
  }

  return connectPromise
}

export const disconnectXrplClient = async () => {
  if (!xrplClient) return
  if (xrplClient.isConnected()) {
    await xrplClient.disconnect()
  }
  xrplClient = null
  connectPromise = null
}
